import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { TaskForm } from './task-form';
import { TaskDto } from '@sr/dto';
import { useEditTaskForm } from './use-edit-task-form';

export const EditTaskDialog = ({ open, onClose, task }: { open: boolean; onClose: () => void; task: TaskDto }) => {
  const { initialValues, handleSubmit } = useEditTaskForm(task, onClose);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Редактировать задачу</DialogTitle>
      <DialogContent>
        <TaskForm initialValues={initialValues} onSubmit={handleSubmit} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
};
